import type { JSX } from 'react'
import type { COLOR } from 'vars/index'

import { useMemo, useRef } from 'react'
import { useCurrentCard } from 'blocks/Grid/hooks'
import { RowSkeletonItem } from 'blocks/Skeletons/components/RowSkeleton/RowSkeleton.styled'
import { Skeleton } from 'blocks/Skeletons/Skeleton'
import { CardsInRow } from 'containers/RowContainer'
import { useClientWidth } from 'utils/hooks'
import { FIXED_INDENTS, LAYOUT } from 'vars/index'
import {
  GridSkeletonInnerSC,
  GridSkeletonSC,
  GridSkeletonTitleSC,
} from './GridSkeleton.styled'

export interface IGridSkeleton {
  cardsAspectRatio?: number
  paddings?: (LAYOUT | FIXED_INDENTS)[]
  rowGap?: FIXED_INDENTS
  totalRows?: number
  tvChannelCard?: boolean
  cardsInRow: CardsInRow
  withTitle?: boolean
  height?: string
  pageBackgroundColor?: COLOR
}

export const GridSkeleton = ({
  cardsAspectRatio = 1.48,
  paddings = [
    FIXED_INDENTS.INDENT_70,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_0,
  ],
  rowGap = FIXED_INDENTS.INDENT_40,
  totalRows = 6,
  tvChannelCard = false,
  cardsInRow = CardsInRow.Horizontal_5,
  withTitle = true,
  height,
  pageBackgroundColor,
}: IGridSkeleton): JSX.Element => {
  const gridNode = useRef<HTMLDivElement>(null)
  const clientWidth = useClientWidth()
  const cardCount = useMemo(() => +cardsInRow.split('_')[1], [cardsInRow])
  const rowDirection = useMemo(() => cardsInRow?.charAt(0), [cardsInRow])
  const countCard = useCurrentCard({
    cardsInRow: cardCount,
    rowDirection,
    clientWidth,
    tvChannelCard,
  })
  const visibleCardCount = countCard || cardCount

  return (
    <Skeleton height={height} pageBackgroundColor={pageBackgroundColor}>
      <GridSkeletonInnerSC paddings={paddings}>
        {Boolean(withTitle) && <GridSkeletonTitleSC />}
        <GridSkeletonSC
          ref={gridNode}
          rowGap={rowGap}
          cardCount={visibleCardCount}
          cardsAspectRatio={cardsAspectRatio}
          totalRows={totalRows}
        >
          {new Array(totalRows * visibleCardCount).fill(' ').map((_, index) => (
            <RowSkeletonItem key={`${Math.random()}_${index}`} />
          ))}
        </GridSkeletonSC>
      </GridSkeletonInnerSC>
    </Skeleton>
  )
}
